module.exports = __webpack_public_path__ + "media/images/goats/Goat in active labor.jpg";